import { useState, useEffect } from "react"
import ContactUs from "./data/ContactUs"
import PaymentGateWay from "./data/PaymentGatewayData"
import { useLocation } from "react-router-dom"

const footerSections = [
  {
    footer_link_headline: "Our Platform",
    items: [
      { label: "Slot Games", link: "/slots" },
      { label: "Live Games", link: "/live-casino" },
      { label: "Sportsbetting", link: "/sportsbook" },
      { label: "Promotions", link: "/promotion" },
      { label: "VIP", link: "/vip" },
    ],
  },
  {
    footer_link_headline: "Links",
    items: [
      { label: "About Us", link: "/about-us" },
      { label: "Articles", link: "/articles" },
      { label: "Android App", link: "/android" },
      { label: "Responsible Gaming", link: "/responsible-gaming" },
      { label: "T&C", link: "/terms-and-conditions" },
      { label: "Survey", link: "https://forms.gle/zfoMbsafVQaNayMB7" },
      {
        label: "24/7 Support",
        link: "#",
        className: "nav-item-chat-support",
      },
    ],
  },
]

const FooterColumn = ({ footer_link_headline, items }) => (
  <div className="fgh-footer-column-section">
    <strong
      className="fgh-strong-style fgh-title-footer"
      style={{ textAlign: "left" }}
    >
      {footer_link_headline}
    </strong>
    <nav aria-label={footer_link_headline}>
      <ul className="footer-links-list">
        {items.map((item, index) => (
          <li key={index} className="footer-link-item">
            <a
              href={item.link}
              className={`footer-link${
                item.className ? " " + item.className : ""
              }`}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  </div>
)

const Footer = () => {
  const currentYear = new Date().getFullYear()
  const location = useLocation()
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [selectedContact, setSelectedContact] = useState(null)

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])
  const isProfilePage = location.pathname.includes("/profile")
  const hideOnProfileMobile = isProfilePage && windowWidth <= 840
  if (hideOnProfileMobile) {
    return null
  }
  return (
    <>
      <footer className="fgh-footer-section">
        <div className="fgh-footer-columns">
          <div className="fgh-footer-links">
            {footerSections.map((section, index) => (
              <FooterColumn
                key={index}
                footer_link_headline={section.footer_link_headline}
                items={section.items}
              />
            ))}
          </div>
          <div className="fgh-payment-section-footer">
            <strong className="fgh-strong-style" style={{ textAlign: "left" }}>
              Payment Gateway
            </strong>
            <PaymentGateWay />
            <span className="fgh-note-text">
              FGH secure payment gateway ensures fast transactions you can
              trust.
            </span>

            <div className="fgh-contact-us-footer " id="contactUs">
              <strong className="fgh-strong-style footer-contact">
                Contact Us
              </strong>
              <div className="fgh-contact-us-footer--contact fgh-contact-us-footer--contact-foot">
                <div
                  onClick={() => setSelectedContact("mobile")}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src="/images/icon/contact-us/mobile-app-icon.webp"
                    alt="Mobile"
                  />
                </div>
                <div
                  onClick={() => setSelectedContact("viber")}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src="/images/icon/contact-us/viber-app-icon.webp"
                    alt="Viber"
                  />
                </div>
                {/* <div
                  onClick={() => setSelectedContact("whatsapp")}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src="/images/icon/contact-us/whatsup-app-icon.webp"
                    alt="WhatsApp"
                  />
                </div> */}
                <div
                  onClick={() => setSelectedContact("telegram")}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src="/images/icon/social-media/telegram.webp"
                    alt="Telegram"
                  />
                </div>
                <div>
                  <a
                    href="mailto:support@fgh.fun"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/images/icon/contact-us/email-app-icon.webp"
                      alt="Email"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span className="fgh-copyright-notice-text">
          © {currentYear} FGH. All rights reserved.
        </span>
      </footer>

      {selectedContact && selectedContact !== "email" && (
        <ContactUs
          type={selectedContact}
          onClose={() => setSelectedContact(null)}
        />
      )}
    </>
  )
}

export default Footer
